<div class="modal-body">
  <div id="sms-recaptcha-container"></div>
  <form class="centermodal__form mb-0" [formGroup]="form" (ngSubmit)="sendSms(); timeOutForVerification()" *ngIf="!verifyPhoneExisting" novalidate>
    <p class="centermodal__title">{{ 'shared.confirmPhoneNumber' | translate }}</p>
    <p class="centermodal__description">
      {{ phoneOtpProvider.translation('phoneEntry', currentPhoneOtpProvider) | translate }}
    </p>
    <label class="field__holder" style="margin: 0 0 30px">
      <app-phone-number inputClass="field" formControlName="phoneNumber" name="phoneNumber" autocomplete="tel-national" [appDisableInput]="isStaticPhoneNumber" required></app-phone-number>
      <span class="field__placeholder">{{ 'shared.yourPhoneNumber' | translate }}</span>
      <small [hidden]="!form.get('phoneNumber').value || !form.get('phoneNumber').hasError('phoneError')" class="text-danger">{{ 'error_invalid_phone_number' | translate }}</small>
    </label>
    <div class="centermodal__button-group">
      <button type="button" class="btn-M btn-filled-cancel" [disabled]="isLoading" (click)="modal.dismiss()">{{ 'button.close' | translate }}</button>
      <button type="submit" class="btn-M btn-filled" [disabled]="form.invalid || isLoading">{{ 'button.forward' | translate }}</button>
    </div>
  </form>
  <form class="centermodal__form mb-0" (ngSubmit)="submitToken()" *ngIf="verifyPhoneExisting" novalidate>
    <p class="centermodal__title">{{ 'shared.confirmYourPhoneNumber' | translate }}</p>
    <p class="centermodal__description" [innerHTML]="phoneOtpProvider.translation('documentCodeSent', currentPhoneOtpProvider) | translate: { phone: formattedPhone }"></p>

    <div class="tokenText__container">
      <label class="field__holder" [appFormControlWrap]="token">
        <input type="tel" class="field" [formControl]="token" name="token" autocomplete="one-time-code" maxlength="6" appOnlyNumbers required />
        <span class="field__placeholder">{{ 'auth.confirmCode' | translate }}</span>
      </label>
      <div class="tokenField">
        <p class="tokenField__alert" *ngIf="isInvalidToken"><i class="tokenField__alert-icon"></i>{{ 'shared.incorrectCode' | translate }}</p>
        <div class="tokenField__resend">
          <span class="tokenField__resend-text">{{ 'shared.notReceivedCode' | translate }}</span>
          <button
            type="button"
            class="tokenField__resend-button btn btn-link btnAnimatedBackground tokenText__btn"
            [disabled]="isVerifyingToken || isLoading || timerService.isCountdownInProgress()"
            (click)="requestCode(); timeOutForVerification()"
          >
            {{ 'shared.resendCode' | translate }}
          </button>
        </div>
      </div>

      <div class="tokenField" *ngIf="hasPhoneOtpFallbackProvider()">
        <div class="tokenField__resend tokenText">
          <span class="tokenField__resend-text">{{ 'shared.orTryBy' | translate }}</span>
          <button
            type="button"
            class="btn btn-link btnAnimatedBackground tokenText__btn greenText"
            [disabled]="isVerifyingToken || isLoading || timerService.isCountdownInProgress()"
            (click)="requestFallbackCode(); timeOutForVerification()"
          >
            {{ phoneOtpFallbackProviderLabel() }} {{ (timerService.isCountdownInProgress() ? 'shared.in' : 'shared.clickingHere') | translate }}
            <div>&nbsp;{{ timerService.isCountdownInProgress() ? formattedTime : '' }}</div>
          </button>
        </div>
      </div>
    </div>
    <div class="centermodal__button-group mt-3">
      <button type="button" class="btn-M btn-filled-cancel" [disabled]="isLoading" (click)="modal.dismiss()" *ngIf="isStaticPhoneNumber">{{ 'button.close' | translate }}</button>
      <button type="button" class="btn-M btn-filled-cancel" (click)="verifyPhoneExisting = false" *ngIf="!isStaticPhoneNumber">{{ 'button.back' | translate }}</button>
      <button type="submit" class="btn-M btn-filled" [disabled]="isLoading">{{ 'button.forward' | translate }}</button>
    </div>
  </form>
</div>
